import Bluebird from 'bluebird';
import * as groupsApi from '../api/groups';
import { shouldFetch } from '../helpers/cache';

export const REQUEST_GROUPS = 'REQUEST_GROUPS';
export const RECEIVE_GROUPS = 'RECEIVE_GROUPS';
export const RECEIVE_GROUP = 'RECEIVE_GROUP';
export const RECEIVE_GROUP_CREATE = 'RECEIVE_GROUP_CREATE';
export const RECEIVE_GROUP_UPDATE = 'RECEIVE_GROUP_UPDATE';
export const RECEIVE_GROUP_DELETE = 'RECEIVE_GROUP_DELETE';

export const requestGroups = () => ({ type: REQUEST_GROUPS });

export const receiveGroups = (siteId, data) => ({
  type: RECEIVE_GROUPS,
  siteId,
  groups: data,
  receivedAt: Date.now(),
});

export const receiveGroup = group => ({
  type: RECEIVE_GROUP,
  group,
});

export const receiveGroupCreate = group => ({
  type: RECEIVE_GROUP_CREATE,
  group,
});

export const receiveGroupUpdate = group => ({
  type: RECEIVE_GROUP_UPDATE,
  group,
});

export const receiveGroupDelete = groupId => ({
  type: RECEIVE_GROUP_DELETE,
  groupId,
});

const shouldFetchSiteGroups = (state) => {
  const { groups } = state.entities;
  if (groups.inflight) {
    return false;
  }

  if (groups.allIds.length === 0 || !groups.lastUpdated) {
    return true;
  }

  return shouldFetch(groups.lastUpdated, { minutes: 1 });
};

export const fetchSiteGroups = siteId => dispatch => {
  dispatch(requestGroups());

  return Bluebird
    .try(() => groupsApi.getSiteGroups(siteId))
    .then(res => res.json())
    .then(res => res.data)
    .then(data => dispatch(receiveGroups(siteId, data)));
};

export const fetchSiteGroupsIfNeeded = (siteId) => (dispatch, getState) => {
  if (shouldFetchSiteGroups(getState())) {
    return dispatch(fetchSiteGroups(siteId));
  }

  return null;
};

export const fetchSiteGroup = (siteId, groupId) => dispatch =>
  Bluebird
    .try(() => groupsApi.getSiteGroup(siteId, groupId))
    .then(res => res.json())
    .then(res => res.data)
    .then(data => dispatch(receiveGroup(data)));

export const createGroup = (siteId, data) => dispatch =>
  Bluebird
    .try(() => groupsApi.createSiteGroup(siteId, data))
    .then(res => res.json())
    .then(res => res.data)
    .then(group => dispatch(receiveGroupCreate(group)));

export const updateGroup = (siteId, groupId, data) => dispatch =>
  Bluebird
    .try(() => groupsApi.updateSiteGroup(siteId, groupId, data))
    .then(res => res.json())
    .then(res => res.data)
    .then(group => dispatch(receiveGroupUpdate(group)));

export const deleteGroup = (siteId, groupId) => dispatch =>
  Bluebird
    .try(() => groupsApi.deleteSiteGroup(siteId, groupId))
    .then(() => dispatch(receiveGroupDelete(groupId)));

export const addGroupUsers = (siteId, groupId, userIds) => dispatch =>
  Bluebird
    .try(() => groupsApi.addGroupUsers(siteId, groupId, userIds))
    .then(res => res.json())
    .then(res => res.data)
    .then(group => dispatch(receiveGroup(group)));

export const removeGroupUser = (siteId, groupId, userId) => dispatch =>
  Bluebird
    .try(() => groupsApi.removeGroupUser(siteId, groupId, userId))
    .then(res => res.json())
    .then(res => res.data)
    .then(group => dispatch(receiveGroup(group)));
